import React from 'react';
import cn from 'classnames';
import { LinkButton } from '@festo-ui/react';
import { NavLink } from 'react-router-dom';
import useFoxPresence from './hooks/useFoxPresence';

import Modal from '../AlertModal/Modal';
import ShareLink from '../ShareLink/ShareLink';

import useTranslation from '../../features/translation/hooks/useTranslation';
import useHeadline from './hooks/useHeadline';

import './Headline.scss';
enum TranslationKeys {
  HEADLINE_NAME = 'headlineName',
  HEADLINE_DESCRIPTION = 'headlineDescription',
  CHANGE_APPLICATION_PARAMETERS = 'changeAppParameters',
  CHANGE_MOTION_TYPE = 'changeMotionType',
}

const Headline: React.FC = () => {
  const {
    linkRef,
    headlineName,
    isFirstPage,
    isResultPage,
    modalOpen,
    goBack,
    handleOk,
    resetApplication,
    cancelModal,
  } = useHeadline();

    // TO-DO: Refactor this to use a better hook

  const t = useTranslation();
  const { hasFoXHeadline } = useFoxPresence();

  return (
    <div className="ems-headline container-fluid">
      {hasFoXHeadline ? null : (
        <>
          <div className="fwe-d-flex fwe-justify-content-space-between">
            <h1 className="ems-main-headline">{t(headlineName)}</h1>
            <div data-testid="headline-links" className="ems-headline__links--desktop">
              <ShareLink />
            </div>
          </div>
          <div className="ems-sub-heading">{t(TranslationKeys.HEADLINE_DESCRIPTION)}</div>
        </>
      )}

      {hasFoXHeadline ? (
        <div data-testid="headline-links" className="ems-headline__links--desktop">
          <ShareLink />
        </div>
      ) : null}

      <Modal isOpen={modalOpen} onCancel={cancelModal} onClose={cancelModal} onOk={handleOk} />

      <NavLink ref={linkRef} to="/" />

      <div
        data-testid="headline-mobile-links"
        className={cn('ems-headline__action-bar', {
          'ems-headline__action-bar--result': isFirstPage,
          'ems-headline__action-bar--entrypage': isFirstPage,
        })}
      >
        {!isFirstPage && (
          <LinkButton
            onClick={isResultPage ? goBack : resetApplication}
            className="ems-button--to-overview"
            icon="arrows-left-2"
          >
            {isResultPage ? t(TranslationKeys.CHANGE_APPLICATION_PARAMETERS) : t(TranslationKeys.CHANGE_MOTION_TYPE)}
          </LinkButton>
        )}

        <div className="ems-headline__links--mobile">
          <ShareLink />
        </div>
      </div>
    </div>
  );
};

export default Headline;
